export default {
    name: process.env.REACT_APP_NAME,
    version: process.env.REACT_APP_VERSION,
    env: 'local',

    //  API Location
    apiUrl: 'http://localhost:8081/api',

    //  Auth Stuff
    authRedirectUri: '',
    authReturnUri: '',
    authDomain: '',
    authAudience: '',
    authClientId: '',
    wellbeingAssessmentUrl: 'https://www.awesomeschools.com/',
}